<template lang="pug">
  layout
    template(v-slot:toolbar)
      b-navbar
        template(v-slot:start)
          ui-navbar-tabs(:items="navbarTabs" v-model="activeTab")

    template(v-if="activeTab==0" v-slot:content)
      layout-form(:value="test" form='test')

    template(v-else-if="activeTab==1" v-slot:content)
      //- h1 plplp

      //- layout: template(v-slot:content)
      //- b-tabs.ui-tabs.has-background-beige(v-model="activeTab")

      //-   //- TAB: Общие данные
      //-   b-tab-item()
      //-     template(slot="header")
      //-       b-icon(icon="information-outline")
      //-       span Общие данные
      //-       b-icon(v-if="test.$isChanged" icon="asterisk" size="is-small" type='id-danger')

      //-     layout-form(:value="test" form='test')

      //-   //- TAB: Вопросы
      //-   b-tab-item(v-if="test.id")
          template(slot="header")
            b-icon(icon="comment-question")
            span Вопросы
            b-icon(v-if="test.questions.$isChanged" icon="asterisk" size="is-small" type='id-danger')

      .columns.m-0
        .column.has-background-light.is-4-tablet.is-4-desktop(v-if="test.questions")
          b-table.has-background-light.is-borderless(v-if="test.questions" :data="test.questions.items" :row-class="questionRowClass" :selected.sync="selectedQuestion" hoverable)
            //- b-table-column(field="id" label="ID" width="30" numeric sortable) {{ row.id }}
            b-table-column(field="title" label="Вопросы:" sortable v-slot="{row}")
              .is-pulled-right
                b-icon(v-if="row.$isChanged" icon="asterisk" type="is-danger" size="is-small")
                b-icon(v-else icon="chevron-right-circle")
              | {{ row.title }}

            //- Добавить вопрос
            form(@submit.prevent="addQuestion()" slot="footer")
              b-field()
                b-input(v-model="newQuestionTitle" placeholder="Добавить вопрос" expanded)
                .control: button.button.is-primary: b-icon(icon="plus")


        .column.is-8-tablet.is-8-desktop
          layout-form(v-if="selectedQuestion" :value="selectedQuestion" form='test-question' @afterSave="onSaveQuestion")
            a.button.has-text-danger(slot="custom-actions" @click="deleteQuestion(selectedQuestion)")
              b-icon(icon='delete')
              span Удалить

          .layout-form(v-else)
            b-message(type="is-info")
              b-icon(icon="arrow-left" size="is-small")
              span Выберите или добавьте вопрос

      //- TAB: Варианты результатов
      //- b-tab-item(label="Результаты" v-if="test.id" icon="poll" disabled)

      //- TAB: Настройки
      //- b-tab-item(label="Настройки" v-if="test.id" icon="settings")
        layout-form(:value="test" form='test-settings')

      //- b-tab-item(label="Доступ" v-if="test.id" icon="lock-open")
        layout-form(:value="test" form='resource-access')



</template>

<script>
import Test from '@/models/Test';
import TestQuestion from '@/models/TestQuestion';
import { indexTabItem } from '@/utils/nav';

export default {
  name: 'view-control-tests-edit',

  data: () => ({
    test: new Test(),
    activeTab: 0,
    selectedQuestion: null,
    newQuestionTitle: '',
    navbarTabs: [
      indexTabItem('Общие данные', 'information-outline'),
      indexTabItem('Вопросы', 'comment-question'),
    ],
  }),

  methods: {
    questionRowClass(row) {
      return this.selectedQuestion && row.id === this.selectedQuestion.id ? 'is-selected' : '';
    },

    onSaveQuestion() {
      this.selectedQuestion.answers.items.forEach(answer => {
        if (answer.$isChanged) {
          answer.$save();
        }
      });
    },

    addQuestion() {
      if (this.test.id && this.newQuestionTitle) {
        const newQuestion = new TestQuestion({
          test_id: this.test.id,
          title: this.newQuestionTitle,
          answers: [],
        });
        this.newQuestionTitle = '';

        newQuestion.$save().then(() => {
          this.selectedQuestion = this.test.questions.add(newQuestion);
        });
      }
    },

    deleteQuestion(question) {
      this.test.questions.$delete(question);
      this.selectedQuestion = null;
    },
  },

  created() {
    this.test.$find(this.$route.params.id, { include: 'questions.answers,category' });
  },
};
</script>
